import styled, { css } from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { HORIZONTAL_PADDING } from '../../constants';
import { ColumnElementBase } from '../column-element-base';
import { type ColumnElement } from '../column-elements';
import { INNER_PADDING, PLAIN_INNER_PADDING } from './constants';
import {
  getAlignRowsMarginsMixin,
  getFeaturesBackgroundMixin,
  getHeadFeaturesMarginsMixin
} from './mixins';

export interface OuterPaddings {
  top: number;
  bottom: number;
}

export type FeatureProps = ColumnElement & {
  $hasHeadFeatures: boolean;
  $isHeadFeature: boolean;
  $isLastFeatureRow: boolean;
  $outerPaddings: OuterPaddings;
};

export const Feature = styled(ColumnElementBase).attrs<FeatureProps>(
  ({ $isHeadFeature }) => ({
    className: createReadableClass(
      {
        component: 'features',
        element: 'feature'
      },
      [$isHeadFeature && 'es-features-head-feature']
    )
  })
)`
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding: ${({
    theme: {
      features: { type }
    }
  }) =>
    `${type === 'plain' ? PLAIN_INNER_PADDING : INNER_PADDING}px ${HORIZONTAL_PADDING}px`};

  ${({
    theme: {
      features: { align }
    }
  }) => css`
    text-align: ${align};
    justify-content: ${align};
  `};

  ${getHeadFeaturesMarginsMixin};
  ${getAlignRowsMarginsMixin};
  ${getFeaturesBackgroundMixin};
`;
